import premiumPlans from 'shared/constants/premium-plans';

function millisecsToMins(value) {
  return value / (60 * 1000);
}

export function getPlan(state) {
  return _.get(state, 'premiumInfo.premiumInfo.product', premiumPlans.NONE);
}

export function isVIP(state) {
  return getPlan(state) === premiumPlans.VIP;
}

export function isFree(state) {
  return getPlan(state) === premiumPlans.NONE;
}

export function getUsageInMins(state) {
  return {
    used: millisecsToMins(_.get(state, 'premiumInfo.usageInfo.confirmed.milliseconds', 0)),
    total: millisecsToMins(_.get(state, 'premiumInfo.premiumInfo.milliseconds', 0)),
  };
}

export function canUpload(state) {
  if (!state.premiumInfo) {
    return false;
  }

  const { premiumInfo, usageInfo: { estimated } } = state.premiumInfo;

  return (
    premiumInfo.milliseconds > estimated.milliseconds &&
    premiumInfo.bytes > estimated.bytes
  );
}



// WEBPACK FOOTER //
// ./src/shared/selectors/premium.js